import { render, staticRenderFns } from "./addprompt.vue?vue&type=template&id=8fad0380&scoped=true"
import script from "./addprompt.vue?vue&type=script&lang=js"
export * from "./addprompt.vue?vue&type=script&lang=js"
import style0 from "./addprompt.vue?vue&type=style&index=0&id=8fad0380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fad0380",
  null
  
)

export default component.exports